import { FormUnit, type GetFormInput } from "@suse-o11y/signal/form";

import { isStringDirty } from "~/tools/is-string-dirty";
import { trim } from "~/tools/trim";

type FormState = FormUnit<string>;

type Input = GetFormInput<FormState>;

function init(initial: Input): FormState {
	return FormUnit(initial, {
		isInputDirty: isStringDirty,
		transform: trim,
	});
}

const FormState = {
	init,
} as const;

export { FormState };
